import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { BID_TYPES } from '@autobid/ui/constants/BID_TYPES'

export function useBarometerBidOnAgent() {
  const { startListen } = useWebSocketStore()
  const { sessionData, isAuthed } = useAutobidAuth()
  const { updateBarometerCarData } = useUpdateCar()

  const bidOnAgent = () => {
    startListen({
      eventName: 'premium.USER_BID_ON_AGENT',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const {
          auctionId,
          carId,
          price: amount,
          userId: user_id,
          nickname: user_nickname,
          status,
          agentBid,
        } = event.context

        updateBarometerCarData(auctionId, carId, (item) => {
          const newBids = [
            {
              user_id,
              user_nickname,
              amount,
              type: BID_TYPES.BID_ON_AGENT,
              timestamp: new Date(event.time * 1000).toISOString(),
              status,
              agent_bid: agentBid,
            },
            ...item.bids,
          ]
          const amIBidder = sessionData.value?.user?.id === user_id

          return {
            ...item,
            bids: newBids,
            price: {
              ...item.price,
              current: amount,
            },
            state: status === 1 ? 'RESERVED' : 'SOLD',
            ...(isAuthed.value
              ? {
                  hasBid: amIBidder ? true : item.hasBid,
                  isHighestBidder: amIBidder,
                }
              : {}),
          }
        })
      },
    })
  }

  return { bidOnAgent }
}
